export default {
  version: '',
};
